import { css } from 'lit-element';

export class Themes {
    // based on this theme, similar to our current colors
    // https://material.io/tools/color/#!/?view.left=1&view.right=0&primary.color=295c8f&secondary.color=ced7db
    // darker grey
    // https://material.io/tools/color/#!/?view.left=1&view.right=0&primary.color=295c8f&secondary.color=B0BEC5
    static get baseTheme() {
        //todo could generate hovers etc in code using rgbs
        return css`
            :host {
                /* --app-primary-color: #295c8f; */
                --app-primary-color: rgb(41, 92, 143);
                --app-primary-color-hover: rgb(41, 92, 143, 0.08);
                --app-primary-color-hover-border: rgb(41, 92, 143, 0.7);

                --app-primary-light-color: rgb(227, 241, 250);
                --app-primary-light-color-hover: rgb(227, 241, 250, 0.60);
                --app-primary-light-color-select: rgb(227, 241, 250, 0.35);

                /*Maybe call this app-dark-gray-color?*/
                --app-primary-dark-color: #2b3540;

                /* this is the text/icon etc color on an element with a primary designation*/
                --app-on-primary-color: #ffffff;
                --app-on-primary-light-color: #000000;
                --app-on-primary-dark-color: #ffffff;


                --app-surface-color: #ffffff;
                --app-background-color: #ffffff;
                --app-content-background-color:#f8f9fa;

                --app-on-surface-color: #000000;
                --app-on-background-color: #000000;
                --app-on-content-background-color:#000000;


                /* secondary colors*/
                --app-secondary-color: rgb(176, 190, 197);
                --app-secondary-color-hover: rgb(176, 190, 197, 0.2);
                --app-secondary-color-hover-border: rgb(176, 190, 197, 0.8);

                --app-secondary-light-color: #d3d7db;




                --app-secondary-dark-color: rgb(128, 142, 149);

                --app-on-secondary-color: #000000;
                --app-on-secondary-light-color: #000000;
                --app-on-secondary-dark-color: #000000;
                /* not sure exactly what we want from these, but success/warn/error/info seem appropriate */
                /* error */
                --app-error-color: #b00020;
                --app-on-error-color: #ffffff;
                --app-error-color-hover: #ffebee;

                --app-dark-text-color: var(--app-primary-dark-color);
                --app-medium-text-color:var(--app-secondary-dark-color)
                --app-light-text-color: white;

                /* success */
                --app-success-color: #00695c;
                --app-on-success-color: #ffffff;
                --app-success-color-hover: #ebffef;

                /* info */
                /* --app-info-color: #feebc8; */
                --app-info-color: #fff8e1;
                --app-info-dark-color: #ffe5b4;

                --app-on-info-color: #000000;

                /* todo: part of component design, figure out this stuff*/
                --menu-select-color: var(--app-primary-light-color-select);
                --menu-selected-color: var(--app-primary-light-color);
                --menu-select-color-hover: var(--app-primary-light-color-hover);

                /* color if not primary, sedondary or disabled */
                --component-default-color: rgba(0, 0, 0, 0.74);
                --component-disabled-color: rgba(0, 0, 0, 0.2);

                /* try to remove*/
                --app-link-color: var(--app-primary-color);

                /* misc */
                --routed-link-color: var(--app-primary-color);
                --side-item-separator-color: var(--app-secondary-color);

                /* gray shades */
                --light-gray-100: #f4f5f6;
                --light-gray-200: #d3d7db;

                --highlight-color: #fffbd3;
            }
        `;
    }
    static getTheme(theme) {
        switch (theme) {
            case 'LIGHT':
                break;
            case 'DARK':
            default:
                return Themes.baseTheme;
        }
    }
}
